import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoJobsAction, 
  setIsFetching, 
  setFetchFailed, 
  setJobsContent,
} from 'Components/InfoJobs/Redux/actions';

export const fetchJobsContent = () => {
  return async (dispatch: Dispatch<InfoJobsAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoJobs;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('JobsPage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.JobsPageViewModel = await response.json();
        dispatch(setJobsContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoJobs/Redux/thunks.tsx